import React, { ReactElement, useState } from 'react';
import { IconButton } from '@chakra-ui/react';
import { Accessible } from '@mui/icons-material';

import { MobileNavOverlay } from '../../layout/MobileNavOverlay';

import { NavItem } from './NavItem';

export const NavTabletAndMobileMenu = (): ReactElement => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <NavItem variant="default" position={'relative'}>
      <IconButton
        aria-label="Open Mobile Navigation"
        icon={<Accessible />}
        onClick={() => setIsOpen(true)}
        bg="transparent"
        fontSize="18px"
      />
      <MobileNavOverlay isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </NavItem>
  );
};
